import React, { FC } from 'react'
import { Circle } from 'react-components'

import { NumberContainer } from './numbered-dot-styles'

export interface NumberedDotProps {
    number: number
    fillColor: string
    textColor?: string
}

export const NumberedDot: FC<NumberedDotProps> = ({ number, fillColor, textColor }) => (
    <Circle radius="1.25rem" padding="0" fillColor={fillColor}>
        <NumberContainer textColor={textColor}>{number}</NumberContainer>
    </Circle>
)

export default NumberedDot
